import React, {
  useEffect,
  createContext,
  useReducer,
  useCallback,
} from "react";
import { useHistory } from "react-router-dom";

const TicketsContext = createContext();

const ticketsReducer = (state, action) => {
  switch (action.type) {
    case "SET_CURRENT_TICKET":
      return { ...state, currentTicket: action.payload };
    case "SET_TAB_OPEN":
      return { ...state, tabOpen: action.payload };
    default:
      return state;
  }
};

const TicketsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ticketsReducer, {
    currentTicket: { id: null, code: null },
    tabOpen: "open",
  });

  const setCurrentTicket = useCallback((ticket) => {
    dispatch({ type: "SET_CURRENT_TICKET", payload: ticket });
  }, []);

  const setTabOpen = useCallback((tab) => {
    dispatch({ type: "SET_TAB_OPEN", payload: tab });
  }, []);

  const history = useHistory();

  useEffect(() => {
    if (state.currentTicket.id !== null && state.currentTicket.uuid) {
      history.push(`/tickets/${state.currentTicket.uuid}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.currentTicket]);

  return (
    <TicketsContext.Provider
      value={{
        currentTicket: state.currentTicket,
        setCurrentTicket,
        tabOpen: state.tabOpen,
        setTabOpen,
      }}
    >
      {children}
    </TicketsContext.Provider>
  );
};

export { TicketsContext, TicketsContextProvider };
